import axios from "axios";
import {factura} from "../FacturaAndDetail/typeFactura";
import {deleteCarts} from "../services/deleteCarts";
import {UPDATE_CART_AMOUNT} from "../services/updateCart";
import {comerceNumber} from "../../consultForm/Helpers/constants";
import {buildFeetypeData,UpdateFeeTypes} from "../../checkout/updateFeetypes";
import {GroupInvoice} from "../types";
import {invoicesPaid} from "../../typesNames/typesNames";
import config from "../../../config/config";
import invoice from "../../resumen/resumeMI/components/invoice";

export const newInvoceStorage    = 'newInvoices';
export const cartsIdStorage      = 'cartsId';
export const UFStorage           = 'dataPayment';
export const InvoicesCanCuscribe = 'invoicesCanSuscribe';
export const suscriptionData     = 'suscriptionData';
export const resumeSuscription   = 'resumeSuscription';

let extras = ['extra6','extra7','extra8'];
let labels = [
    {
        name: "Servicio",
        value: 'extra6'
    },
    {
        name: "Equipo a cuotas",
        value: 'extra7'
    },
    {
        name: "Contenidos Adicionales",
        value: 'extra8'
    },
];

let originalInvoiceData = [
    "id",
    "identificacionEmpresa",
    "moneda",
    "total",
    "extra1",
    "extra2",
    "extra3",
    "facturaId",
    "extra4",
    "extra5",
    "extra6",
    "extra7",
    "extra8",
    "extra9",
    "extra10",
    "documento",
    "extra11",
    "extra12",
    "extra14",
    "monto_a_pagar",
    "total",
    "consulta"
];



////////////////////////////////////////////////////////
//  FIND CURRENT INVOICE IN RESPONSE
export const findInvoice= (facturas:any,id:any, filial:number, param:string)=>{
     let property = filial !== 1 ? param : 'identificacionEmpresa';
     return facturas.filter((item:any)=> item[property] == id )[0];
}


////////////////////////////////////////////////////////
//  CREATE INVOICE DISCRIMINADO
let armaDiscriminado = (data:any) =>{
    let discriminado  = data.discriminado;
    let findExtra:any = null;
    if(discriminado){
        findExtra = (name:string)=> [...discriminado]
            .filter((ext:any)=> ext.name === name )[0]
    }
    let items = [...extras]
        .map((item:string)=>({
            name           : item,
            active         : !!(discriminado ? (findExtra(item).originalAmount) : +data[item]),
            amount         : discriminado ? (findExtra(item).amount ? findExtra(item).amount : findExtra(item).originalAmount) : data[item],
            originalAmount : discriminado ? (findExtra(item).originalAmount) : data[item],
            legend         : labels.filter((label:any)=> label.value === item)[0].name,
        }));
    return items;
}


////////////////////////////////////////////////////////
//  CREATE INVOICE
export const CreateInvoiceGroup = (data:factura[],reset:boolean = false) => { 

    let Groups = data.map( (item:any) => (
        { ...item,
            active          : reset ? (item.extra11 ? true : false) : (item.extra11 ? true : !!item.total),
            originalAmounts : {
                total  : reset ? 0 : item.total,
                extra6 : reset ? 0 : item.extra6,
                extra7 : reset ? 0 : item.extra7,
                extra8 : reset ? 0 : item.extra8,
            },
            consulta     : item.consulta,
            discriminado : armaDiscriminado(item),
            total: reset ? 0 : item.total
        }
    ));
    return Groups;
}

////////////////////////////////////////////////////////
//  ACTUALIZA LOS MONTOS DE LAS FACTURAS CON EL ONCHANGE
export let updateInvroiceGroup = (
    id: number,
    data: any,
    invoicesCopy:any,
) => {

    let copy = [...invoicesCopy]
        .map((item: any) => {
            if (item.id === id) {
                item.totalToPay = data.total;
                item.extra6     = data.extra6;
                item.extra7     = data.extra7;
                item.extra8     = data.extra8;
            }
            return item
        });
    return copy;
}





////////////////////////////////////////////////////////
//  CHECK LINE TYPE FOR CONSULT SUSCRIPTION
export let Check_line_Type = async (checkLine : (number:string)=> void) => {
    let PaymentData               = sessionStorage.getItem(UFStorage);
    let PData:any                 = JSON.parse(PaymentData || '').facturas[0]
    let ConsultaSuscriptionNumber = '';

    // VERIFICA EL TIPO DE LINEA

    if (PData) {
        if (PData.extra4 === 'GTA') ConsultaSuscriptionNumber = PData.identificacionEmpresa;
        else if(PData.referencia)   ConsultaSuscriptionNumber = PData.referencia;
        else ConsultaSuscriptionNumber = PData.identificacionEmpresa;

        // SE HACE LA CONSULTA A FACTURAS PARA SUSCRIBIR
        let consulta = await checkLine(ConsultaSuscriptionNumber);
        return consulta;
    }
    return {
        result  : false,
        message : 'No se cumplieron las validaciones.',
        numer   : ConsultaSuscriptionNumber
    }
}


////////////////////////////////////////////////////////
// elminia los valores en session storage
export let ClearItemsSessionStorage = () =>{
    sessionStorage.removeItem('resume')
    sessionStorage.removeItem('dataPayment')
    sessionStorage.removeItem('filial')
    sessionStorage.removeItem('tipoResponse')
}


////////////////////////////////////////////////////////
// elminia los valores en session storage
export const mask = (texto:string) => {
    let textofinal:any = "";
    if (texto !== undefined) {
        let textoarray = texto.toString().split("");
        for (var i = 0; i < textoarray.length; i++) {
            if (i < 3 || i > 7) {
                textofinal = [...textofinal, textoarray[i]]
            } else {
                textofinal = [...textofinal, "*"];
            }
        }
    }
    return textofinal;
}

///////////////////////////////
// Calcula total por los extras
let calculaTotal = (discriminado:any)=>{
    let extraxActivos  = [...discriminado].filter((ext:any)=> ext.active);
    return extraxActivos.reduce((item:any,index:any)=> parseInt(index.amount) + item,0)
}


///////////////////////////////
// check si viene con extras
let checkExtras = (factura:any)=>{
    let originales    = factura.originalAmounts;
    let extras = Object.keys({...originales})
        .filter((e:any)=> e!== 'total')
        .map((extra:string) => (originales[extra]))
    let todosEnCero = [...factura.discriminado].every((it:any)=> !it.amount);
    let tieneDiscriminado = [...extras].some((val:number)=> val);
    let resetdiscriminado = [...factura.discriminado].map((ex:any)=> {
        ex.amount = ex.amount ? ex.amount : originales[ex.name]
        ex.active = !!parseInt(originales[ex.name]);
        return ex;
    })
    return {
        todosEnCero,
        tieneDiscriminado,
        resetdiscriminado,
    }
}


////////////////////////////////////////////////////////
// Actualiza extra
export const changeExtra = (
    factura:any,
    extra:string,
    typeChange:string,
    value:number
) =>{
    let discriminadoCopia       = [...factura['discriminado']]
    let invoiceUpdated:any         = {...factura};

    if(typeChange) {
        invoiceUpdated.discriminado = discriminadoCopia.map((inv:any)=>{
            if(inv.name === extra) {
                inv.active = !inv.active
                invoiceUpdated[extra] = inv.active ?  inv.originalAmount : 0;
                inv.amount = inv.active ?  inv.originalAmount : 0;
            }
            return inv;
        })
    }
    else {
        invoiceUpdated.discriminado = discriminadoCopia.map((inv:any)=>{
            if(inv.name === extra) {
                invoiceUpdated[extra] = value;
                inv.amount = value;
                inv.active = !!value;
            }
            return inv;
        })
    }

    invoiceUpdated['total']        = calculaTotal(invoiceUpdated['discriminado']);
    invoiceUpdated['active']       = invoiceUpdated['total'];
    return invoiceUpdated;
}


////////////////////////////////////////////////////////
// Actualiza UltraFactura
export const changeUltraFacturas = (data:any,facturaId:string, nuevaFactura:any) =>{
    let dataCopy = [...data].map((fac:any)=>{
        if(fac.id === facturaId) return nuevaFactura
        return fac;
    })
    return dataCopy;
}

////////////////////////////////////////////////////////
// remover factura from UltraFactura
export const removerFactura = (data:any,facturaId:string) =>{
    let dataCopy = data.filter((fac:any)=> fac.id !== facturaId)
    return dataCopy;
}


////////////////////////////////////////////////////////
// toogle factura from UltraFactura
export const toggleFactura = (data:any,facturaId:string) =>{
    let factura = [...data].filter((fact:any)=>fact.id === facturaId )[0]
    factura.active = !factura.active
    if(factura.active && checkExtras(factura).todosEnCero && checkExtras(factura).tieneDiscriminado ){
        factura.discriminado = checkExtras(factura).resetdiscriminado;
        factura.total        = calculaTotal(factura.discriminado);
    }
    factura.total = factura.total ? factura.total : factura.originalAmounts.total;
    let dataCopy = [...data].map((fac:any)=>{
        if(fac.id === facturaId) return factura;
        else return fac;
    })
    return dataCopy;
}

//////////////////////
// calcula los totales
export const calculaTotales = (invoices:any) =>{
    let total = [...invoices]
        .filter((ext:any)=> ext.active)
        .reduce((item:any,index:any)=> {
            let val = index.total;
            if(typeof val !== "number")
            return parseInt(val) + item;
            else return val + item;
        }, 0)
    return total;
}

//////////////////////
// calcula los totales extras
export const calculaTotalesExtras = (discriminado:any) =>{
    let total = [...discriminado]
        .filter((ext:any)=> ext.active)
        .reduce((item:any,index:any)=> {
            let val = index.amount;
            if(typeof val !== "number")
                return parseInt(val) + item;
            else return val + item;
        }, 0)
    return total;
}


/////////////////
// Resetea extras
let reseteaExtras = (originalAmounts :any,factura:any, cond:boolean)=>{
    let {total,extra6,extra7,extra8} = originalAmounts;
    if(!factura.total && total) factura.discriminado = armaDiscriminado(factura);
    if(extra6 || extra7 || extra8) factura.total = calculaTotalesExtras(factura.discriminado);
    else factura.total = factura.total  ? factura.total  : total;
    return factura;
}


///////////////////////////////////////////
// resetea la factura sus valores iniciales
export const resetInvoice = (CurrentInvoice:any,cond:boolean) =>{
    let oAmount     = CurrentInvoice.originalAmounts;
    let factura:any = reseteaExtras(oAmount,CurrentInvoice, cond);
    factura.active  = oAmount.total && cond;
    return factura;
}

////////////////////////////////
// Selecciona todas las facturas
export const selectAllInvoices = (CurrentInvoices:any, cond:boolean) =>{
    return [...CurrentInvoices].map((item:any)=> resetInvoice(item,cond))
}


///////////////////////////////////////
// verifica si todas estan selecionadas
export const checkInvoices = (CurrentInvoices:any) =>{
    let onlyWithAmount = CurrentInvoices.filter((item:any)=> item.originalAmounts.total);
    let seleccionadas = onlyWithAmount.map((i:any)=> i.active)
    return (seleccionadas.every((e:boolean)=> e) && CurrentInvoices.some((i:any)=> !!i.originalAmounts.total));
}

///////////////////////////////////////
// filtra o busca facturas
export const filterInvoices = (CurrentInvoices:any,value:string) =>{
    if(!value) return [];
    let filtered = CurrentInvoices.filter((item:any)=>
        item.identificacionEmpresa.toString().includes(value) ||
        (item.total && item.total.toString().includes(value))
    );
    return filtered;
}


///////////////////////////////////////
// ADD monot_a_pagar to invoice
export const buildInvoicesMontoPagar = (inovices:any) =>{
    let invoicesRefactor =  inovices
    .filter((inv:any)=> inv.active)
    .map((inovice:any)=>{
        let monto_a_pagar = {...inovice}.discriminado.reduce(
            (item:any,index:any)=>( 
                {...item,[index.name]:index.amount}),{}
            )
            monto_a_pagar.total = inovice.total;
        let newInvoice = {...inovice,monto_a_pagar}
        return newInvoice;
    })
    return buildInvoiceForUpdate(invoicesRefactor);
}


////////////////////////////////////////
// Build extra 10 id and values invoices
export const buildExtra10 = (inovices:any) =>{
    let facturasConMontos = inovices.filter((inv:any) => inv.total);
    let ids    = `id:${facturasConMontos.map((ele:any) => ele.id + ':')}`;
    let values = `valor${facturasConMontos.map((ele:any)=> ':' + ele.total )}`;
    return (`${ids}${values}`).replaceAll(',','');
}


////////////////////////////////////////
// Build INVOICES for update
export const buildInvoiceForUpdate = (invoices:any)=> {
    let n = invoices.map((item:any)=>
            [...originalInvoiceData]
                .reduce((ele:any,index:any)=>(
                {...ele,[index]:item[index]}
            ),{})
    )
    return n;
}



////////////////////////////////////////
// Transform data invoice
export let transformInvoice = (invoice:any,filial:number)=>{
    let values_metrotel        = [ 'telefono', 'extra1', 'factura_id', 'fechaExpiracion', 'id', 'id_cliente', 'identificacionEmpresa','total'];
    let values_telebucaramanga = ['facturaId', 'fecha_expiracion', 'id', 'telefono', 'total'];
    let values:any = null;
    
    let invoiveExample = {
        id                     : '',
        identificacionEmpresa  : '',
        moneda                 : 'COP',
        total                  : 0,
        extra1                 : '',
        extra2                 : '',
        extra3                 : '',
        facturaId              : '',
        extra4                 : '',
        extra5                 : false,
        extra6                 : 0,
        extra7                 : 0,
        extra8                 : 0,
        extra9                 : '',
        extra10                : false,
        documento              : '',
        extra11                : false,
        extra12                : '',
    }

    if(filial == 2){

        values = values_telebucaramanga.reduce((ele:any,index:any)=>({...ele,[index]:invoice[index]}),{})
        values.identificacionEmpresa = values.facturaId.toString();
        values.facturaId = values.facturaId.toString()
        values.documento = values.telefono;
        values.consulta  = invoice.consulta;
    }else{
        values = values_metrotel.reduce((ele:any,index:any)=>({...ele,[index]:invoice[index]}),{})
        values.facturaId = !!values.factura_id ? values.factura_id.toString(): values.factura_id;
        values.identificacionEmpresa = !!values.facturaId ? values.facturaId.toString() : values.facturaId;
        values.documento = values.telefono;
        values.consulta  = invoice.consulta;
    }

    return {...invoiveExample, ...values}
}



////////////////////////////////////////
// Validate and delete carts
export const validateIdsTodelete = async (current:string[])=> {
    let Carts    = JSON.parse(sessionStorage.getItem(cartsIdStorage) || 'null');
    if(current.length !== 1) return;
    let idsCarts = Carts
        .filter((cart:any)=> cart.invoiceID !== current[0])
        .map((item:any)=> item.cartId );
    let borrados = await deleteCarts(idsCarts);
    if(borrados.result) return true;
    return false;
}


//////////////
// Update cart
export const buildCartAndUpdate = async (invoices:any)=> {
    let ultraFacturas      = JSON.parse(sessionStorage.getItem('dataPayment') || '{}');
    ultraFacturas.facturas = buildInvoicesMontoPagar(invoices);
    ultraFacturas.total    = invoices.reduce((item:any,index:any)=> (item + index),0);
    let filial =  comerceNumber[sessionStorage.getItem('filial')||'movistar']
    let result =   await UPDATE_CART_AMOUNT({ultraFacturas},filial);
    return result;
}



/////////////////////////////////////////
// Recolect values and saved in s-storage
export const recoletNewVals = (val:any,storage:string)=>{
    let values        = JSON.parse(sessionStorage.getItem(storage) || 'null');
    if(values) values = [...values,val]
    else values       = [val];
    sessionStorage.setItem(storage,JSON.stringify(values));
    return values;
}

///////////////////////////////////////////////
// handler new invoices when individual request
export const updateUltraFacturas = async (
    storage:string = '',
    invoice:any,
    type   :string,
    filial :number,
    sendToCloud: boolean,
)=>{
    
    let store    = sessionStorage.getItem(storage) || 'null';
    let UF       = JSON.parse(store);
    let invoices = UF.facturas;
    let param    = filial !== 1 ? 'facturaId' : 'identificacionEmpresa';

    let id:number = parseInt(invoice[param]);
    
    if(type === "add") invoices = [...invoices,invoice]
    else invoices = [...invoices].filter((inv:any)=> parseInt(inv[param]) !== id )

    UF.facturas = invoices;
    sessionStorage.removeItem(storage);
    sessionStorage.setItem(storage,JSON.stringify(UF));

    let updated = true;
    if(sendToCloud) updated = await UPDATE_CART_AMOUNT({ultraFacturas:UF},filial);

    return updated;
}


///////////////////////////////////////////////
// handler new invoices when individual request
export const CheckIfFilialCanSuscribe = (invoices:any)=>{

    if(invoices.length !== 1) return false;

    let storage              = sessionStorage.getItem(InvoicesCanCuscribe);
    let invoicesCanSubscribe = JSON.parse(storage || 'null');
    let UF:any               = JSON.parse(sessionStorage.getItem(UFStorage) || 'null');
    let originalInvoice      = UF.facturas[0]

    if(invoices.length === 1 && invoicesCanSubscribe){
        let invoice = [...invoicesCanSubscribe]
            .filter((inv:any)=> inv.number === invoices[0]['identificacionEmpresa'])[0]
        if(invoice && invoice.action){
            let {action} = invoice;
            let {
                fecha_expiracion, total, factura_id, nombre_proyecto,
            } = originalInvoice;
            let resume:string = JSON.stringify({
                fecha_expiracion,
                total,
                factura_id,
                nombre_proyecto,
                accion:action,
                total_balance : invoice.total,
                paymentData   : [originalInvoice]
            });
            sessionStorage.setItem(resumeSuscription, resume);
            return true
        }
        else{
            sessionStorage.removeItem(resumeSuscription);
            return false;
        }
    }
    return false;
}



///////////////////////////////////////////////
//  SAVE INVOICES ACTIVE IN S-STORAGE
export const saveActiveInvoices =(invoices:any,):boolean =>{
    
    let invoicesActive = [...invoices].filter((inv:any)=> inv.active);
    sessionStorage.setItem(invoicesPaid,JSON.stringify(invoicesActive))
    return invoicesActive.length > 1;
}


////////////////////////////////////////////////////////
//  UPDATE Data base mongo
////////////////////////////////////////////////////////

export let UpdateMongo = async (data: any) => {
    let obj = {result:false};

    const records = data.map((r: any) => {
      return r.extra3;
    });
    
    const dataRecords = {
        "records": records
    }
    try{
        await axios({
            method:'post',
            url:`${config.amonServices}/invoice/update`,
            data: dataRecords
        })
            .then((resp:any)=>{
                if(resp.data.success){
                    obj.result = true;
                }
            })
            .catch(e=>{
                obj.result = false;
            })
    }
    catch (e) {
        obj.result = false;
    }
    return obj;
}